<template>
  <form class="form-table-settings">
    <input-checkbox
      v-for="column in columns"
      :title="column.name"
      :key="column.id"
      :value="column.is_visible"
      v-on:input="onInput(column.id, $event)"
    />
    <button
      class="form-table-settings__button"
      type="button"
      v-on:click="closePopover"
    >Закрыть</button>
  </form>
</template>

<script>
import { builtInPopoverMixin } from '@/mixins/builtInPopoverMixin';
import InputCheckbox from '@/components/InputCheckbox.vue';

/**
 * @description Компонент формы настроек таблицы.
 */
export default {
  components: { InputCheckbox },
  methods: {
    onInput(id, isVisible) {
      const columns = this.columns.map((candidate) => (candidate.id === id
        ? { ...candidate, is_visible: isVisible } : candidate));
      this.$emit('change', columns);
    },
  },
  mixins: [builtInPopoverMixin],
  name: 'FormTableSettings',
  props: {
    columns: { default: () => [], type: Array },
  },
};
</script>

<style lang="scss">
@use "@/scss/buttons";

.form-table-settings {
  padding: 30px 20px;
  min-width: 300px;
  display: flex;
  flex-direction: column;

  &__button {
    margin-top: 10px;
    @include buttons.btn-blue(100%, 2.5rem, 1rem);
  }
}
</style>
